export default __webpack_public_path__ + "static/media/10.Pravila vzyatia gytkosti citologyi.7271e595.pdf";